import { keyframes, css } from '@emotion/react';

// ─── Keyframes ───────────────────────────────────────────────────────────────

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const riseUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(32px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// ─── Easing ───────────────────────────────────────────────────────────────────
// Smooth iOS-style deceleration curve
const ease = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

// ─── Animation helpers ───────────────────────────────────────────────────────

/** Header bar — slides gently down from above */
export const slideDownAnimation = (duration = 0.45, delay = 0) => css`
  animation: ${fadeDown} ${duration}s ${ease} ${delay}s both;
`;

/** Question number / label — fades down */
export const fadeDownAnimation = (duration = 0.4, delay = 0) => css`
  animation: ${fadeDown} ${duration}s ${ease} ${delay}s both;
`;

/** Avatar / listen pill — pure fade, no movement */
export const fadeInAnimation = (duration = 0.4, delay = 0) => css`
  animation: ${fadeIn} ${duration}s ease ${delay}s both;
`;

/** Question text — fades up softly */
export const fadeUpAnimation = (duration = 0.45, delay = 0) => css`
  animation: ${fadeUp} ${duration}s ${ease} ${delay}s both;
`;

/** Dock — rises up from the bottom */
export const slideUpAnimation = (duration = 0.5, delay = 0) => css`
  animation: ${riseUp} ${duration}s ${ease} ${delay}s both;
`;

// ─── Screen-level transition (ready → question page) ─────────────────────────

export const screenTransition = (isTransitioning: boolean) => ({
  transition: `opacity 0.3s ease-out, transform 0.3s ease-out`,
  opacity: isTransitioning ? 0 : 1,
  transform: isTransitioning ? 'translateY(-16px)' : 'translateY(0)',
});

// ─── Legacy exports kept for any unused imports ───────────────────────────────
export const slideUpOutAnimation = () => ({});
export const scaleInAnimation = () => ({});
export const fadeINOutAnimation = () => ({});
